import { render, staticRenderFns } from "./BrokerAuthAuditDetail.vue?vue&type=template&id=5d038d9f&scoped=true"
import script from "./BrokerAuthAuditDetail.vue?vue&type=script&lang=js"
export * from "./BrokerAuthAuditDetail.vue?vue&type=script&lang=js"
import style0 from "./BrokerAuthAuditDetail.vue?vue&type=style&index=0&id=5d038d9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d038d9f",
  null
  
)

export default component.exports